import { EditCellPopup } from './EditCellPopup';

export default EditCellPopup;
